import styled from "styled-components";
import { CHECKBOX_ACCENT } from "../Checkbox";

interface CheckboxStyleProps {
    $checked: boolean;
    $accent: CHECKBOX_ACCENT;
    $isLightBorder?: boolean;
}

export const CheckboxInput = styled.input`
    position: absolute;
    left: -9999px;
    opacity: 0;
`;

export const CheckboxLabel = styled.label<CheckboxStyleProps>(({ theme, $checked }) => {
    return {
        position: "relative",
        cursor: "pointer",
        display: "inline-block",
        width: "18px",
        height: "18px",
        backgroundColor: "transparent",
        borderRadius: theme.spacing.xxSmall,
        transition: "border 0.3s",
        border: (() => {
            if ($checked) {
                return `1px solid ${theme.colors[theme.colorMode].primary}`;
            } else {
                return `1px solid ${theme.colors[theme.colorMode].border_Subtle_Secondary}`;
            }
        })(),
    };
});

export const CheckboxTick = styled.svg<Pick<CheckboxStyleProps, "$checked">>(({ theme, $checked }) => {
    return {
        height: theme?.spacing?.large,
        width: theme?.spacing?.large,
        transition: "transform 0.3s cubic-bezier(0.23, 1, 0.32, 1) 0ms",
        position: "absolute",
        left: `calc(${theme.spacing.xxxSmall} * -1)`,
        top: `calc(${theme.spacing.xxxSmall} * -1)`,
        opacity: 1,
        fill: theme.colors[theme.colorMode].primary,
        transform: $checked ? "scale(1.1)" : "scale(0)",
    };
});
